export class GeneralError extends Error {
  public constructor() {
    super()

    this.message = 'errors.general'
  }
}
